import React from "react";
import {  useParams } from "react-router-dom";
import { Box, Divider } from "@mui/material";
import UserAccess from "components/User/UserAccess";

import { ContractorUserDetailContext } from "contexts/ContractorUserDetailContext";
import { useGetContractorUserDataDetailQuery } from "store/services/contractorUserApi";

import ContractorUserBasicDetail from "./contractorComponents/ContractorUserBasicDetails";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { ContractorTab } from "./contractorComponents/ContractorProfileTab";
import { useAppMeta, useAuth } from "hooks";

const ContractorUserDetailScreen = () => {

  const { id } = useParams();

  const { isAccountAdmin, isSystemAdmin } = useAuth();

  const breadcrumbs = [
    { title: "Contractor", path: "/app/crm/contractorUser/list" },
    { title: "Contractor Detail" },
  ];

  const {
    data: contractorUserDetail,
    isLoading: loadingContractorUser,
    error,
  } = useGetContractorUserDataDetailQuery(id);

  const PageActions = () => (
    <Box display="flex" alignItems="center" gap={2}>
      {(isSystemAdmin || isAccountAdmin) && (
        <UserAccess
          sourceDetail={contractorUserDetail}
          typeRefSource={"Contractor"}
        />
      )}

      {/* <Link to={`/app/crm/contractorUser/${id}/edit`} state={{ from: "detail" }}>
        <Button variant="contained" startIcon={<EditOutlined />}>
          Edit
        </Button>
      </Link> */}
    </Box>
  );

  useAppMeta("Contractor Detail");

  return (
    <ContractorUserDetailContext.Provider
      value={{ contractorUserDetail, loadingContractorUser }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingContractorUser}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <ContractorUserBasicDetail />
          <Divider />
          <ContractorTab />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </ContractorUserDetailContext.Provider>
  );
};

export default ContractorUserDetailScreen;
